import { useGetPrimeToken } from 'clients/api';
import { Button, Dropdown } from 'components';
import { useIsConnectedAccountVip } from 'hooks/useIsConnectedAccountVip';
import { useTranslation } from 'libs/translations';
import { useAccountAddress, useAuthModal } from 'libs/wallet';
import { AccountModal } from './AccountModal';
import { UserButton } from './UserButton';

export const ConnectButton: React.FC = () => {
  const { accountAddress } = useAccountAddress();
  const { isConnectedAccountVip } = useIsConnectedAccountVip();

  const { openAuthModal } = useAuthModal();

  const { t } = useTranslation();

  const handleConnectButtonClick = () => {
    openAuthModal({
      analyticVariant: 'header_connect_button',
    });
  };

  const { data: getPrimeTokenData, isLoading: isGetPrimeTokenLoading } = useGetPrimeToken({
    accountAddress,
  });
  const isAccountPrime = !!getPrimeTokenData?.exists;

  if (isGetPrimeTokenLoading) {
    return undefined;
  }

  if (accountAddress) {
    return (
      <Dropdown
        menuClassName="mt-5 shadow-none border-0 bg-background-active"
        triggerOnHover
        menuPosition="right"
        optionsDom={() => (
          <AccountModal
            address={accountAddress}
            isPrime={isAccountPrime}
            isVip={isConnectedAccountVip}
          />
        )}
      >
        {({ handleToggleDropdown, isDropdownOpened }) => (
          <UserButton
            onClick={handleToggleDropdown}
            isActive={isDropdownOpened}
            address={accountAddress}
            isPrime={isAccountPrime}
            isVip={isConnectedAccountVip}
          />
        )}
      </Dropdown>
    );
  }

  return <Button onClick={handleConnectButtonClick}>{t('connectButton.connect')}</Button>;
};
